import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import AccountTypeSelection from './AccountTypeSelection';
import BirthdayForm from './BirthdayForm';
import { OnboardingTransferForm } from './TransferForm';
import AddressForm from './AddressForm';
import TaxIdForm from './TaxIdForm';
import DocumentAcceptance from './DocumentAcceptance';
import MultiStepForm, { step } from './common/MultiStepForm';
import DiscloureQuestions from './DisclosureQuestions';
import FundingSource from './FundingSource';
import { useLanguage } from '../utils/LanguageContext';
import './SignupForm.css';
import translations from '../components/ComponentsTranslations.lang.json';
import NameForm from './NameForm';
import PhoneNumberForm from './PhoneNumberForm';
import PayrollElectionForm from './PayrollElectionForm';
import EmploymentStatusForm from './EmploymentStatus';
import AccountLossRiskQuestionForm from './AccountLossRiskQuestion';
import InvestmentObjectiveRiskQuestionForm from './InvestmentObjectiveRiskQuestion';
import IncomeLevelForm from './IncomeLevel';
import NetWorthForm from './NetWorth';
import { useRefreshingAsync } from './common/commonHooks';
import { EmploymentSetupStatus } from '../shared/constants/employmentConstants';
import VerifyTaxIdForm from './VerifyTaxIdForm';
import { useState } from 'react';
import ResidencyStatusForm from './ResidencyStatusForm';

const OnboardingForm = () => {
  const { lang } = useLanguage(translations);
  const { isLoggedIn, api, userEmployments } = useAuth();

  const [activationCode] = useState(useParams().activationCode);

  const investmentAccounts = useRefreshingAsync(async () => isLoggedIn && (await api.getInvestmentAccounts()));
  const investmentAccount = investmentAccounts?.[0];
  const { investmentAccountId } = investmentAccount ?? {};

  const navigate = useNavigate();

  const employment = userEmployments?.[0];
  const onboardingWithEmployer = activationCode || employment?.status === EmploymentSetupStatus.INITIATED_BY_EMPLOYEE;

  const submitAccountAndNavigateToDashboard = async () => {
    await api.submitInvestmentAccount(investmentAccountId);
    navigate('/account');
  };

  const steps = [
    ...(activationCode
      ? [step(lang('taxIdTitle'), VerifyTaxIdForm, { activationCode })]
      : [
          //no additional steps
        ]),

    step(lang('fullNameTitle'), NameForm),
    step(lang('phoneNumberTitle'), PhoneNumberForm),
    step(lang('accountTypeTitle'), AccountTypeSelection, { investmentAccount }),
    step(lang('accountLossRiskQuestionTitle'), AccountLossRiskQuestionForm),
    step(lang('investmentObjectiveRiskQuestionTitle'), InvestmentObjectiveRiskQuestionForm),
    step(lang('birthdayTitle'), BirthdayForm),
    step(lang('addressTitle'), AddressForm),

    ...(onboardingWithEmployer
      ? [
          //make payroll contributions for employer-funded
          step(lang('electionTitle'), PayrollElectionForm, { employment }),
        ]
      : [
          //set up deposits for self-funded, and get tax id
          step(lang('depositTitle'), OnboardingTransferForm, { investmentAccountId }),
          step(lang('taxIdTitle'), TaxIdForm),
        ]),

    step(lang('residencyStatusTitle'), ResidencyStatusForm),
    step(lang('disclosureQuestionsTitle'), DiscloureQuestions),

    ...(onboardingWithEmployer
      ? [
          //employer funded no need to ask for employment status or income source
        ]
      : [
          //required to ask otherwise
          step(lang('employmentStatusTitle'), EmploymentStatusForm),
          step(lang('fundingSourceTitle'), FundingSource),
        ]),

    step(lang('incomeLevelTitle'), IncomeLevelForm),
    step(lang('netWorthTitle'), NetWorthForm),
    step(lang('acceptTermsTitle'), DocumentAcceptance),
  ];

  return <MultiStepForm steps={steps} onCompletion={submitAccountAndNavigateToDashboard} />;
};

export default OnboardingForm;
